const Check = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M18.5802 7.2684C19.0752 7.67779 19.1421 8.40792 18.7296 8.89918L11.4379 17.5834C11.2281 17.8333 10.922 17.9841 10.5945 17.9988C10.2671 18.0136 9.94848 17.8909 9.7167 17.6609L5.34171 13.3188C4.8861 12.8666 4.8861 12.1334 5.34171 11.6813C5.79732 11.2291 6.53601 11.2291 6.99162 11.6813L10.4633 15.1268L16.937 7.41666C17.3495 6.92539 18.0852 6.85901 18.5802 7.2684Z" fill="currentColor"/>
    </svg>
  );
};

export default Check;